import { useEffect, useState } from 'react'
import {
  faAngular,
  faCss3,
  faGitAlt,
  faHtml5,
  faJsSquare,
  faReact,
} from '@fortawesome/free-brands-svg-icons'
import Loader from 'react-loaders'
import AnimatedLetters from '../AnimatedLetters'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import './index.scss'

const About = () => {
  const [letterClass, setLetterClass] = useState('text-animate')

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass('text-animate-hover')
    }, 3000)
  }, [])

  return (
    <>
      <div className="container about-page">
        <div className="text-zone">
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={['A', 'b', 'o', 'u', 't', ' ', 'm', 'e']}
              idx={15}
            />
          </h1>
          <p>
          Hi, I'm Yaseen, a Full-Stack Developer with a passion for creating attractive and engaging websites
          that are both user-friendly and dynamic. I have professional experience working at the University of Kirkuk,
          where I contributed to building and maintaining a variety of university-specific web systems.
          These applications were designed to digitalize internal workflows and improve operational efficiency across departments,
          allowing staff to perform their tasks more effectively.
          </p>
          <p align="LEFT">
          Before that, I was a proud graduate of Microverse, a remote software development school that emphasizes hands-on
          learning through collaboration. During my time at Microverse, I dedicated over 1200 hours to coding and
          honing my skills through pair programming, team projects, and remote collaboration with developers from
           around the world.
          </p>
          <p align="LEFT">
          In my free time, I continue to challenge myself by tackling algorithms and solving
          problems on HackerRank. With my extensive coding experience and dedication to the
          craft, I am ready to bring my skills to new and exciting projects.
          </p>
          
         </div>

        <div className="stage-cube-cont">
          <div className="cubespinner">
            <div className="face1">
              <FontAwesomeIcon icon={faAngular} color="#DD0031" />
            </div>
            <div className="face2">
              <FontAwesomeIcon icon={faHtml5} color="#F06529" />
            </div>
            <div className="face3">
              <FontAwesomeIcon icon={faCss3} color="#28A4D9" />
            </div>
            <div className="face4">
              <FontAwesomeIcon icon={faReact} color="#5ED4F4" />
            </div>
            <div className="face5">
              <FontAwesomeIcon icon={faJsSquare} color="#EFD81D" />
            </div>
            <div className="face6">
              <FontAwesomeIcon icon={faGitAlt} color="#EC4D28" />
            </div>
          </div>
        </div>
      </div>
      <Loader type="pacman" />
    </>
  )
}

export default About
